import request from '@/utils/request'


// 查询年级班级列表
export function listSchoolGrade(query) {
  return request({
    url: '/biz/admin/school/grade/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询年级班级分页
export function pageSchoolGrade(query) {
  return request({
    url: '/biz/admin/school/grade/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询年级班级详细
export function getSchoolGrade(data) {
  return request({
    url: '/biz/admin/school/grade/detail',
    method: 'get',
    params: data
  })
}

// 新增年级班级
export function addSchoolGrade(data) {
  return request({
    url: '/biz/admin/school/grade/add',
    method: 'post',
    data: data
  })
}

// 批量新增班级
export function batchAddSchoolGrade(data) {
  return request({
    url: '/biz/admin/school/grade/add/batch',
    method: 'post',
    data: data
  })
}

// 修改年级班级
export function updateSchoolGrade(data) {
  return request({
    url: '/biz/admin/school/grade/edit',
    method: 'post',
    data: data
  })
}

export function updateSort(data) {
  return request({
    url: '/biz/admin/school/grade/sort',
    method: 'post',
    data: data
  })
}


// 删除年级班级
export function delSchoolGrade(data) {
  return request({
    url: '/biz/admin/school/grade/delete',
    method: 'post',
    data: data
  })
}


export function importData (data) {
  return request({
    url: '/biz/admin/school/grade/import',
    method: 'post',
    data: data
  })
}